import styled from '@emotion/styled';
import styleUtils from '../../styles/utils';
import theme from '../../themes/default';

const {
  borderRadius,
  color: { designSystem },
} = theme;

export const AlertRoot = styled('div')`
  padding: 9px 13px;
  border-radius: ${borderRadius.medium};
  border-width: 1px;
  border-style: solid;
  color: ${designSystem.blackOpacity87};

  ${({ type }) => {
    switch (type) {
      case 'error':
        return `
          border-color: ${designSystem.error};
          background-color: ${designSystem.background.light.error};
        `;
      case 'warning':
        return `
          border-color: ${designSystem.notificationLight};
          background-color: ${designSystem.background.light.warning};
        `;
      case 'success':
        return `
          border-color: ${designSystem.blackOpacity12};
          background-color: ${designSystem.background.light.success};
        `;
      case 'announcement':
      case 'info':
        return `
          border-color: ${designSystem.blackOpacity12};
          background-color: ${designSystem.background.light.information};
        `;
      case 'loading':
        return `
          border-color: ${designSystem.blackOpacity12};
          background-color: ${designSystem.grey10};
          color: ${designSystem.blackOpacity60};
        `;
      default:
        return '';
    }
  }}
`;

export const AlertBody = styled('div')`
  ${styleUtils.flex.container({
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  })};
`;

export const AlertLayout = styled('div')`
  ${styleUtils.flex.container({
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  })};
  flex-direction: ${({ type }) => (type === 'vertical' ? 'column' : 'row')};
  flex-grow: 1;
`;

export const AlertMessageRoot = styled('div')`
  flex-grow: 1;
  weight: 400;
  font-size: 14px;
  line-height: 20px;
`;

export default {};
